import { BackgroundOverlay } from '@/components/Tile';
import styled from '@emotion/styled';
import { ReactNode } from 'react';
import { AssetCard, IAssetCardProps } from './AssetCard';

const StyledAssetCard = styled(AssetCard)`
    display: flex;
    flex-direction: column;
    color: white;
    justify-content: center;
    font-size: 1.6rem;
    align-items: center;
    gap: 8px;

    .BackgroundOverlay {
        overflow: hidden;
        border-radius: 6px;
    }
` as typeof AssetCard;

export const BoxInnerImage = styled.div<{ src: string; showBlurredBackground?: boolean }>`
    position: absolute;
    top: 0;
    left: 0;
    background: url(${({ src }) => src}) center no-repeat black;
    background-size: ${({ showBlurredBackground }) => (showBlurredBackground ? 'contain' : 'cover')};
    height: calc(100% + 2px);
    width: calc(100% + 2px);
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.black[200]};

    &:hover {
        &::after {
            background: #fff;
            opacity: 0.15;
            width: 100%;
            height: 100%;
            position: absolute;
            border-radius: 8px;
            top: 0;
            left: 0;
            content: '';
        }
    }
`;

interface Props<T> extends Omit<IAssetCardProps<T>, 'children'> {
    src: string;
    children?: ReactNode;
    showBlurredBackground?: boolean;
}

export function ImageAssetCard<T>({ src, children, showBlurredBackground, ...props }: Props<T>) {
    return (
        <StyledAssetCard {...props}>
            {children}
            {showBlurredBackground && <BackgroundOverlay bg={src} />}
            <BoxInnerImage className="image-asset-card-image" src={src} showBlurredBackground={showBlurredBackground} />
        </StyledAssetCard>
    );
}
